<template>
    <div class="profile-details">
        <form>
            <input
                v-if="isDataLoaded"
                type="hidden"
                name="id"
                :value="patientId"
            />
        </form>

        <b-row class="skeleton" v-if="!isDataLoaded || isBusinessLoading">
            <b-col md="2" class="image">
                <div></div>
            </b-col>
            <b-col md="5" class="content">
                <div></div>
                <div></div>
                <div></div>
                <div class="smaller"></div>
                <div class="smaller"></div>
                <div></div>
                <div></div>
                <div class="smaller"></div>
                <div></div>
                <div class="smaller"></div>
            </b-col>
            <b-col md="5" class="content">
                <div></div>
                <div></div>
                <div class="smaller"></div>
                <div></div>
                <div class="smaller"></div>
                <div></div>
                <div></div>
                <div></div>
                <div class="smaller"></div>
            </b-col>
        </b-row>

        <b-row v-if="isDataLoaded && !isBusinessLoading" class="patient">
            <b-col xl="2" md="2" sm="6">
                <patient-photo
                    :patient="patient"
                    v-on="$listeners"
                    :refreshPhotoCount="refreshPhotoCount"
                />
                <div
                    class="wellness-div my-2"
                    v-if="
                        _isExtensionEnabled('WELLNESS') &&
                        _hasAccess('patient.wellness.view') &&
                        activeWellnessPlanList.length > 0
                    "
                >
                    <span
                        class="badge bg-light m-1"
                        v-b-tooltip.hover.top
                        title="Active Wellness Plan"
                        v-for="(plan, index) in activeWellnessPlanList"
                        v-show="index < 5"
                        :key="'plan' + index"
                        @click="openWellnessTab()"
                    >
                        {{ plan.template ? plan.template.name : "-" }}</span
                    >
                    <span
                        class="badge bg-light m-1"
                        v-if="activeWellnessPlanTotal > 5"
                        @click="openWellnessTab()"
                    >
                        + {{ activeWellnessPlanTotal - 5 }} more</span
                    >
                </div>
            </b-col>
            <b-col xl="5" md="4" sm="6">
                <!-- edit -->
                <patient-edit
                    ref="patientEdit"
                    v-if="mode === 'EDIT'"
                    :patient="patient"
                    @edit-saved="editSaved"
                />

                <!-- view -->
                <patient-profile
                    v-else
                    ref="patientProfile"
                    :patient="patient"
                    @load="$emit('load')"
                />
            </b-col>
            <b-col xl="5" md="6" sm="12">
                <patient-reminder
                    ref="patientReminder"
                    :reminders="reminders"
                />
            </b-col>
        </b-row>
    </div>
</template>
<style type="text/css">
.wellness-div span.badge {
    font-size: 12px;
    cursor: pointer;
}
.wellness-div {
    overflow-x: clip;
}
</style>
<script>
import PatientEdit from "./patient-edit";
import PatientProfile from "@/components/patient/sub/patient-profile";
import PatientReminder from "@/components/patient/sub/patient-reminder";

export default {
    components: {
        PatientPhoto: () => import("@/components/patient-photos/photo-display"),
        PatientEdit,
        PatientProfile,
        PatientReminder
    },
    props: {
        mode: {
            type: String
        },
        patient: {
            type: Object
        },
        refreshPhotoCount: {
            type: Number
        }
    },
    data() {
        return {
            CI_APPS: process.env.CI_APPS
        };
    },
    watch: {
        patientId(value) {
            if (value) {
                this.getReminders();
            }
        }
    },
    computed: {
        patientId() {
            return this.patient ? this.patient.id : "";
        },
        reminders() {
            return this.$store.getters["patient/reminders"];
        },
        isDataLoaded() {
            return this.patient ? true : false;
        },
        activeWellnessPlanTotal() {
            let wellnessPlan = this.$store.getters["patient/wellnessPlan"];

            if (wellnessPlan && wellnessPlan.meta) {
                return wellnessPlan.meta.total;
            }

            return 0;
        },
        activeWellnessPlanList() {
            let wellnessPlan = this.$store.getters["patient/wellnessPlan"];

            return wellnessPlan ? wellnessPlan.resources : [];
        },
        isBusinessPage() {
            return this.$store.getters["isBusinessPage"];
        },
        isBusinessLoading() {
            return this.$store.getters["isBusinessLoading"];
        }
    },
    beforeDestroy() {
        // this.$store.dispatch("patient/clearDetails");
    },
    methods: {
        saveEdit() {
            this.$refs.patientEdit.save();
        },
        editSaved(details) {
            this.$emit("edit-saved", details);
        },
        getReminders() {
            this.$store.dispatch("patient/getReminders", this.patientId);
        },
        openWellnessTab() {
            this.$emit("show-plan");
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
.profile-details table tbody tr td:first-child {
    font-weight: bold;
}

.profile-details .patient .table th,
.profile-details .patient .table td {
    padding: 0px;
    line-height: 30px;
}
</style>
